<div [class]="skinName">
    <div class="input-container">
        @if (!error) {
        <h2 class="uk-modal-title">{{ configService.localeKeys?.['common_keys.manage_all_devices.text'] }}</h2>
        }
        @if (error) {
        <h2  class="uk-modal-title">{{configService.localeKeys?.['device_management.too_many_dev.error'] || "Too many devices are using this account"}}</h2>
        }
        @if (error) {
            <div class="error-img"><img src="/branding/theme/assets/static_assets/ic-exclaimation-for-lbg.svg"></div>
        }
        @if (!error) {
            <p class="device-notify-info">{{ configService.localeKeys?.['account.active_on_devices.text'] || "This account is currently active on all of these devices" }}</p>
        }
        @if (error) {
            <p class="device-notify-info">{{configService.localeKeys?.['device_management.too_many_devices.error'] || "To continue signing in,please remove this account from any other device."}}</p>
        }
        <p class="device-notify-info">{{configService.localeKeys?.['device_management.you_can.text'] || "You can"}}
            <span class="notify-link" (click)="openUikitDialog('#all-signout')">{{configService.localeKeys?.['device_management.sign_out_all.btn'] || "Sign out of all the devices"}}</span>
            @if(!userId || (userId && applicationService.userLoginBy == 'manual' && (applicationService.userIntegrationType !== 'api' && applicationService.userIntegrationType !== 'sso' && applicationService.userIntegrationType !== 'ftp' && applicationService.userIntegrationType !== 'soap'))){
                <span class="or">{{configService.localeKeys?.['device_management.or.text'] || "or"}}</span>
            }
            @if(!userId || (userId && applicationService.userLoginBy == 'manual' && (applicationService.userIntegrationType !== 'api' && applicationService.userIntegrationType !== 'sso' && applicationService.userIntegrationType !== 'ftp' && applicationService.userIntegrationType !== 'soap'))){
                <span class="notify-link" (click)="openUikitDialog('#change-password')">{{configService.localeKeys?.['device_management.change_password.btn'] || "Change your password"}}</span> 
            } 
            {{configService.localeKeys?.['device_management.sign_out_for_security.text'] || "for added security."}}
        </p>
        @if(!hideDevices){
            <div class="devices-container">
                @for (device of devices; track device; let i=$index ) {
                <div class="device">
                    <div class="device-detail">
                        @if(editDevice != i && device.device_type == 'web' && device.device_title){
                            <div  class="device-name" > 
                                <span><img src="branding/theme/assets/static_assets/ic-laptop.svg" class="device-icon"> {{device.device_title}}
                                    @if(device.stream_status == 1 && innerWidth > 470){
                                    <span >
                                        <span class="streaming-section"><img src="branding/theme/assets/static_assets/ic-separator.svg"></span> {{configService.localeKeys?.['device_management.currently_streaming.tag'] || "Curent Streaming"}}
                                    </span>
                                    }
                                </span> 
                                <span (click)="openEdit(i)" class="device-edit-btn"><img src="branding/theme/assets/static_assets/ic-edit-on-dbg.svg"> {{configService.localeKeys?.['account.edit.text'] ||"Edit"}}</span>
                            </div>
                        }
                        @if ( editDevice != i && (device.device_type == 'ios' ||device.device_type == 'android') && device.device_title) {
                            <div class="device-name"> 
                                <span><img src="branding/theme/assets/static_assets/ic-mobile.svg" class="device-icon"> {{device.device_title}}
                                @if(device.stream_status == 1 && innerWidth > 470){
                                    <span > 
                                        <span class="streaming-section"><img src="branding/theme/assets/static_assets/ic-separator.svg"></span> {{configService.localeKeys?.['device_management.currently_streaming.tag'] || "Curent Streaming"}}
                                    </span>
                                }
                                </span> 
                                <span (click)="openEdit(i)" class="device-edit-btn"><img src="branding/theme/assets/static_assets/ic-edit-on-dbg.svg"> {{configService.localeKeys?.['account.edit.text'] ||"Edit"}}</span>
                            </div>
                        }
                        @if(editDevice != i && (device.device_type != 'web' && device.device_type != 'ios' && device.device_type != 'android') && device.device_title){
                            <div class="device-name">
                                <span><img src="branding/theme/assets/static_assets/ic-tv.svg" class="device-icon"> {{device.device_title}} 
                                @if(device.stream_status == 1 && innerWidth > 470){
                                    <span > 
                                        <span class="streaming-section"><img src="branding/theme/assets/static_assets/ic-separator.svg"></span> {{configService.localeKeys?.['device_management.currently_streaming.tag'] || "Curent Streaming"}}
                                    </span>
                                }
                                </span> 
                                <span (click)="openEdit(i)" class="device-edit-btn"><img src="branding/theme/assets/static_assets/ic-edit-on-dbg.svg"> {{configService.localeKeys?.['account.edit.text'] ||"Edit"}}</span>
                            </div>
                        }
                        @if(showEdit && editDevice == i && device.device_title){
                            <div class="device-name"> 
                            <span class="device-name-container">
                                @if(device.device_type == 'web'){
                                <span >
                                    <img  src="branding/theme/assets/static_assets/ic-laptop.svg" class="device-icon">
                                </span>
                                }
                                @if(device.device_type == 'ios' || device.device_type == 'android'){
                                <span >
                                    <img  src="branding/theme/assets/static_assets/ic-mobile.svg" class="device-icon">
                                </span>
                                }
                                @if(device.device_type != 'web' && device.device_type != 'ios' && device.device_type != 'android'){
                                <span >
                                    <img  src="branding/theme/assets/static_assets/ic-tv.svg" class="device-icon">
                                </span>
                                }
                                <form class="form-inline device-edit" [formGroup]="inputForm">
                                    <input type="text" class="form-control" placeholder={{device.device_title}} formControlName="newName" maxlength="15">
                                    <div class="action-btns">
                                        <button type="submit" [disabled]="isInputEmpty" (click)="editName(device)" class="device-submit">{{configService.localeKeys?.['common_keys.submit.btn'] || "Submit"}}</button>
                                        <button  (click)="cancelEdit()" class="device-cancel">{{configService.localeKeys?.['common_keys.cancel.text'] || "Cancel"}}</button>
                                    </div>
                                </form>
                           </span> 
                            </div>
                        }
                        @if(device.stream_status == 1 && innerWidth < 471) {
                            <div class="ip stream-icon">
                            <img src="branding/theme/assets/static_assets/ic-currently-streaming-in-concurrent-device-on-dbg.svg" class="ip-icon">{{configService.localeKeys?.['device_management.currently_streaming.tag'] || "Curent Streaming"}}
                            </div>
                        }
                        @if(device.ip_address){
                            <div class="ip">
                            <img src="branding/theme/assets/static_assets/ic-ip-address-in-concurrent-device.svg" class="ip-icon">{{device.ip_address}}
                            </div>
                        }
                        @if(device.updated_at){
                            <div class="date" >
                            <img src="branding/theme/assets/static_assets/ic-time-in-concurrent-device.svg" class="time-icon">{{device.updated_at | datetimeFormat}}
                            </div>
                        }
                        <div class="place">
                            <span> 
                                @if(device.city_or_country){
                                    <span ><img src="branding/theme/assets/static_assets/ic-location-in-concurrent-device.svg" class="location-icon">{{device.city_or_country}}</span> 
                                }
                            </span>
                            @if(currentDevice == device.device_id){
                            <span  class="dt-btn current-btn">{{configService.localeKeys?.['device_management.current_device.text'] ||"Current Device"}}</span>
                            }
                            @if(currentDevice != device.device_id){
                            <span class="dt-btn"><button class="user-signout-btn" (click)="opensignoutDialog(i)">{{configService.localeKeys?.['common_keys.sign_out.btn'] || "Sign Out"}}</button></span>
                            }
                        </div>
                    </div>
                    <!-- device signout popup begin -->
                    <div id="{{i}}" uk-modal="esc-close: false; bg-close: false;" class="uk-flex-top acc-modal device-signout">
                        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
                            <div style="margin-top:0px;margin-bottom: 15px"><img src="/branding/theme/assets/static_assets/ic-exclaimation-for-lbg.svg"></div>
                            <h2 class="uk-modal-title" style="margin-top:0px;"> {{configService.localeKeys?.['common_keys.are_you_sure.text'] || "Are you sure?"}}</h2>
                            <p>{{configService.localeKeys?.['device_management.remove_dev.part1.text'] || "By doing this,"}} "{{device.device_title}}" {{configService.localeKeys?.['device_management.remove_dev.part2.text'] || "will sign out of this account."}}</p>
                            <div><button  class="btn btn-solid" [disabled]="disableSignoutButton" (click)="removeDevice(device, i)">{{configService.localeKeys?.['common_keys.sign_out.btn'] || "Sign Out"}}</button></div>
                            <div><button  class="btn btn-clear" (click)="closeSignout(i)">{{configService.localeKeys?.['common_keys.cancel.text'] || "Cancel"}}</button></div>
                        </div>
                    </div>
                    <!-- device signout popup end -->
                </div>
                }
            </div>
        }

        @if(hideDevices){
            <div class="loader">
                <img class="loader-img loader-size" src="branding/theme/assets/static_assets/ic-app-loader.svg" alt="">
            </div>
        }

            <!-- all device signout popup begin -->
            <div id="all-signout" uk-modal="esc-close: false; bg-close: false;" class="uk-flex-top acc-modal">
                <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
                    <div style="margin-top:0px;margin-bottom: 15px"><img src="/branding/theme/assets/static_assets/ic-exclaimation-for-lbg.svg"></div>
                    <h2 class="uk-modal-title" style="margin-top:0px;"> {{configService.localeKeys?.['common_keys.are_you_sure.text'] || "Are you sure?"}}</h2>
                    <p> {{configService.localeKeys?.['device_management.remove_all_dev.text'] || "By doing this,this account will be sign out across all devices."}}</p>
                    <div><button  class="btn btn-solid" (click)="removeAllDevice('',1)">{{configService.localeKeys?.['common_keys.sign_out.btn'] || "Sign Out"}}</button></div>
                    <div><button  class="btn btn-clear" (click)="closeAllSignout()">{{configService.localeKeys?.['common_keys.cancel.text'] || "Cancel"}}</button></div>
                </div>
            </div>
            <!-- all device signout popup end -->
    
            <!-- change-password pop up for the mobile page begin -->
            <div id="change-password-mobile" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
                <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
                    <button id="change-password-hide" class="uk-modal-close-default uk-close-large" type="button" uk-close>
                        <!-- <img src="branding/theme/assets/static_assets/model-close.svg" alt="close icon"> -->
                    </button>
                    <h2 class="uk-modal-title">
                        {{ configService.localeKeys?.edit_info_title }}</h2>
                    <p>{{ configService.localeKeys?.edit_password_description }}</p>
                    <app-change-password></app-change-password>
                </div>
            </div>
            <!-- change-password pop up for the mobile page end -->
    
        <!-- <button (click)="removeDevice('',0)" class="uk-button uk-button-default submit-btn">{{ configService.localeKeys?.usr_dvic_btn_rm_dvice_def }}</button> -->
    </div>
</div>